import React, { useMemo, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import * as Icons from "react-bootstrap-icons";
import PropTypes from "prop-types";

const iconOptions = Object.keys(Icons).map((name) => ({
    value: name,
    label: name.replace(/([a-z])([A-Z])/g, "$1 $2"),
    Icon: Icons[name],
}));

const IconPickerModal = ({
    show,
    onHide,
    onSelect,
}) => {
    const [search, setSearch] = useState("");

    const filteredIcons = useMemo(() => {
        return iconOptions.filter((item) =>
            item.label.toLowerCase().includes(search.toLowerCase())
        );
    }, [search]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            centered
        >
            <Modal.Header
                closeButton
                className="sticky-top bg-white"
                style={{ zIndex: 1055 }}
            >
                <Modal.Title>Select Icon</Modal.Title>
            </Modal.Header>

            <Modal.Body
                style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    paddingTop: "0rem",
                }}
            >
                {/* Sticky Search */}
                <div
                    className="sticky-top bg-white pb-2 pt-4"
                    style={{ zIndex: 1050 }}
                >
                    <Form.Control
                        placeholder="Search Icon..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* Icons */}
                <div className="row g-2 mt-2">
                    {filteredIcons.map((item) => {
                        const Icon = item.Icon;

                        return (
                            <div
                                key={item.value}
                                className="col-4 col-md-3"
                            >
                                <button
                                    type="button"
                                    className="btn btn-light border w-100 h-100"
                                    onClick={() => {
                                        onSelect(item.value);
                                        onHide();
                                    }}
                                >
                                    <Icon size={20} />

                                    <div
                                        style={{
                                            fontSize: "10px",
                                            marginTop: "4px",
                                        }}
                                    >
                                        {item.label}
                                    </div>
                                </button>
                            </div>
                        );
                    })}
                </div>
            </Modal.Body>
        </Modal>
    );
};

IconPickerModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onSelect: PropTypes.func,
};

export default IconPickerModal;